module.exports = __webpack_public_path__ + "img/pic4.6368d7e2.png";